import { useEffect, useState } from "react";
import { CalendarCheck } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";

export default function BookVisit() {
  const [projects, setProjects] = useState([]);
  const [form, setForm] = useState({ name: "", phone: "", preferred_date: "", project_name: "", pickup_required: false });

  useEffect(() => { api.get("/projects").then((r) => setProjects(r.data)); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) return toast.error("Please enter your name and phone");
    await api.post("/leads", { ...form, source: "Website", status: "Site Visit" });
    toast.success("Site visit booked! Our team will confirm your slot shortly.");
    setForm({ name: "", phone: "", preferred_date: "", project_name: "", pickup_required: false });
  };

  return (
    <div className="font-body">
      <div className="bg-[#08341f] py-16 text-center text-white">
        <p className="text-sm uppercase tracking-[0.25em] text-[#D4AF37] font-semibold">Book Site Visit</p>
        <h1 className="font-heading text-4xl lg:text-5xl font-bold mt-3">Free Site Visit — Pickup Included</h1>
      </div>
      <div className="max-w-xl mx-auto px-5 py-14">
        <form onSubmit={submit} className="rounded-2xl border border-gray-100 shadow-[0_12px_40px_rgba(11,93,59,0.1)] p-8 space-y-5" data-testid="book-visit-form">
          <CalendarCheck className="text-[#0B5D3B]" size={36}/>
          <input data-testid="visit-name" value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})} placeholder="Full Name" className="w-full rounded-lg border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#0B5D3B]"/>
          <input data-testid="visit-phone" value={form.phone} onChange={(e)=>setForm({...form,phone:e.target.value})} placeholder="Phone Number" className="w-full rounded-lg border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#0B5D3B]"/>
          <input data-testid="visit-date" type="text" onFocus={(e)=>e.target.type='date'} value={form.preferred_date} onChange={(e)=>setForm({...form,preferred_date:e.target.value})} placeholder="Preferred Date" className="w-full rounded-lg border border-gray-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#0B5D3B]"/>
          <Select value={form.project_name} onValueChange={(v)=>setForm({...form,project_name:v})}>
            <SelectTrigger data-testid="visit-project" className="h-[46px] rounded-lg"><SelectValue placeholder="Select Project" /></SelectTrigger>
            <SelectContent>{projects.map((p)=><SelectItem key={p.id} value={p.name}>{p.name}</SelectItem>)}</SelectContent>
          </Select>
          <div className="flex items-center justify-between rounded-lg bg-gray-50 px-4 py-3">
            <span className="text-sm font-medium text-gray-700">Pickup Required?</span>
            <Switch data-testid="visit-pickup" checked={form.pickup_required} onCheckedChange={(v)=>setForm({...form,pickup_required:v})}/>
          </div>
          <button data-testid="visit-submit" className="w-full rounded-full bg-[#0B5D3B] text-white py-3.5 font-semibold hover:bg-[#094e32] transition-colors">Book Free Site Visit</button>
        </form>
      </div>
    </div>
  );
}
